import React from 'react';
import Logger from '../../util/Logger';
import { eventApi } from '../../api/EventApi';
import _ from 'lodash';
import * as math from 'mathjs';
import './RatingDistribution.css';
import { storeMultipleRatingData } from '../../features/ai-insights/components/prompts/multipleRatingPrompt';

export default class RatingDistribution extends React.Component {

  constructor (props) {
    super(props);

    this.state = this.buildStateFromDistribution(props.initialDistribution);
  }

  componentDidMount () {
    if (!Array.isArray(this.props.initialDistribution)) {
      this.fetchDist();
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.idea !== prevProps.idea && !Array.isArray(this.props.initialDistribution)) {
      this.fetchDist();
      return;
    }

    if (this.props.initialDistribution !== prevProps.initialDistribution &&
      Array.isArray(this.props.initialDistribution)) {
      this.setState(this.buildStateFromDistribution(this.props.initialDistribution));
    }
  }

  buildStateFromDistribution = (data = []) => {
    const distArray = [];
    let total = 0;
    const cache = {};

    for (const d of (data || [])) {
      total += d.value;
      cache[d.label] = d.value;
    }

    for (let i = 5; i > 0; i--) {
      const count = cache[i.toString()] ? cache[i.toString()] : 0;
      const pct = total > 0 ? (count / total * 100).toFixed(0) : 0;
      distArray.push({
        label: i + ' Star',
        count: count ? count : 0,
        value: i,
        pct: pct,
        style: {
          width: pct + 'px'
        }
      });
    }

    const voteArray = [];
    for (const dist of distArray) {
      for (let i = 0; i < dist.count; i++) {
        voteArray.push(dist.value);
      }
    }

    const hasVotes = voteArray.length > 0;
    return {
      distArray: distArray,
      voteArray: voteArray,
      min: hasVotes ? math.min(voteArray) : 0,
      max: hasVotes ? math.max(voteArray) : 0,
      mean: hasVotes ? math.mean(voteArray) : 0,
      median: hasVotes ? math.median(voteArray) : 0,
      std: hasVotes ? math.std(voteArray) : 0,
      variance: hasVotes ? math.variance(voteArray) : 0
    };
  }

  fetchDist () {
    const { event, idea } = this.props;
    eventApi.getRatingDistribution(event.id, idea.id)
      .then(data => {
        Logger.info('Dists', data);
        const nextState = this.buildStateFromDistribution(Array.isArray(data) ? data : []);

        // Store data in cache for AI Insights
        try {
          const { event, idea } = this.props;
          if (event && idea && event.id && idea.id) {
            const eventId = event.id;
            const ideaId = idea.id;

            // Store the data in cache
            storeMultipleRatingData(eventId, ideaId, nextState.distArray, {
              min: nextState.min,
              max: nextState.max,
              median: nextState.median,
              mean: nextState.mean,
              std: nextState.std,
              variance: nextState.variance,
              totalVotes: nextState.voteArray.length,
              itemName: idea.name || 'Unknown Item'
            });
          }
        } catch (error) {
          Logger.error('Error storing multiple rating data', error);
        }

        this.setState(nextState);

      }).catch(error => {
        Logger.error('Error getting dashboard cards: ', error);
        // TODO Handle
      });
  }

  render () {
    return (
      <div className="rating-distribution">
        <div className="distribution row">
          <div className="col-md-9 pr-5">
            <table className="table table-sm mt-3 ml-2">
                <tr>
                  <th>Mean</th>
                  <th>Std</th>
                  <th>Variance</th>
                  <th className="spacer"></th>
                  <th>Median</th>
                  <th>Min</th>
                  <th>Max</th>
                </tr>
              <tr>
                <td>{this.state.mean.toFixed(1)}</td>
                <td>{this.state.std.toFixed(1)}</td>
                <td>{this.state.variance.toFixed(1)}</td>
                <td className="spacer"></td>
                <td>{this.state.median.toFixed(1)}</td>
                <td>{this.state.min}</td>
                <td>{this.state.max}</td>
              </tr>
            </table>
          </div>
          <div className="col-md-1">
            <div className="dist-chart">
            {
              _.map(this.state.distArray, (dist) =>
              <div class="row">
                <div className="label">{dist.label}</div>
                <div className="hz-bar-container">
                  <div className="hz-bar" style={{ width: dist.style.width }}></div>
                </div>
                <div className="pct">{dist.pct}%</div>
              </div>
              )
            }
            </div>
          </div>

        </div>
      </div>
    );
  }
}
